export const ALPHABETICAL_SORTING = 'ALPHABETICAL_SORTING';
export const PRICE_ASC_SORTING = 'PRICE_ASC_SORTING';
export const AVAILABLE_SORTINGS_LIST = [ALPHABETICAL_SORTING, PRICE_ASC_SORTING];
